// BrimLight/common/schemas/collections/series.js
import { z } from "zod";

const SeriesSchema = z.object({
    _id: z.string().optional(),
    subscriptionId: z.string(),
    name: z.string().min(1, "Series name is required."),
    description: z.string().optional().nullable(),

    genre: z.enum([
        'sci-fi', 'fantasy', 'mystery', 'thriller', 'comedy', 'drama',
        'romance', 'horror', 'adventure', 'documentary', 'educational'
    ]).optional().nullable(),

    videoStyle: z.enum([
        'cinematic_realistic', 'pixar_animation', 'ghibli_style', 'anime_90s',
        'claymation', 'stop_motion', 'watercolor_painting', 'oil_painting',
        'charcoal_sketch', 'pencil_drawing', 'comic_book', 'graphic_novel',
        'low_poly_3d', 'vaporwave', 'cyberpunk', 'steampunk', 'fantasy_art',
        'sci_fi_concept_art', 'vintage_film', 'noir_film', 'documentary', 'isometric'
    ]).optional().nullable(),


    defaultNarratorVoice: z.string().optional().nullable().describe("Composite voice ID for the default narrator."),

    // Default asset selections
    defaultCharacterIds: z.array(z.string()).optional().default([]),
    defaultEnvironmentIds: z.array(z.string()).optional().default([]),
    defaultPropIds: z.array(z.string()).optional().default([]),

    tags: z.array(z.string()).optional().default([]),
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default SeriesSchema;